import React from "react"

export default function SliderNextArrow(props: any) {
  const { className, style, onClick } = props
  return (
    <div
      className={className}
      style={{
        ...style,
        background: "url(/assets/img/right-arrow-purple-button.png)",
        backgroundSize: "contain",
        padding: "12px"
      }}
      onClick={onClick}
    />
  )
}
